export default __webpack_public_path__ + "static/media/allAccets.03e4bf43.svg";